import { useEffect, useState } from "react";
import {
  entComputeArrear,
  entCreateArrear,
  entListArrears,
  entListCorrections,
} from "../salaryEnterpriseApi";
import { useToast } from "../../../Context/ToastContext";
import DatePickerField from "../../../../components/common/DatePickerField";
import EmployeeSelect from "../../../../components/common/EmployeeSelect";

export default function SalaryArrearsCorrections() {
  const toast = useToast();
  const [arrears, setArrears] = useState([]);
  const [corrections, setCorrections] = useState([]);
  const [computeResult, setComputeResult] = useState(null);
  const [arrearForm, setArrearForm] = useState({
    employee_id: "",
    previous_ctc: "",
    new_ctc: "",
    effective_from: "",
    as_of_date: new Date().toISOString().slice(0, 10),
  });

  async function load() {
    const [a, c] = await Promise.all([entListArrears(), entListCorrections()]);
    setArrears(a || []);
    setCorrections(c || []);
  }

  useEffect(() => {
    load().catch(() => {});
  }, []);

  async function runCompute() {
    try {
      const res = await entComputeArrear({
        ...arrearForm,
        previous_ctc: Number(arrearForm.previous_ctc),
        new_ctc: Number(arrearForm.new_ctc),
        arrear_type: "salary_revision",
      });
      setComputeResult(res);
      toast.success("Arrear computed");
    } catch (e) {
      toast.error(e?.detail || "Compute failed");
    }
  }

  async function saveArrear() {
    try {
      await entCreateArrear({
        ...arrearForm,
        previous_ctc: Number(arrearForm.previous_ctc),
        new_ctc: Number(arrearForm.new_ctc),
        arrear_type: "salary_revision",
      });
      toast.success("Arrear saved");
      await load();
    } catch (e) {
      toast.error(e?.detail || "Save failed");
    }
  }

  return (
    <div className="bw-stack">
      <h2 className="bw-section-title">Corrections & arrears</h2>

      <div className="bw-form-grid">
        <div className="bw-field xl-4">
          <EmployeeSelect
            label="Employee"
            required
            value={arrearForm.employee_id}
            onChange={(id) => setArrearForm((p) => ({ ...p, employee_id: id }))}
            selectClassName="bw-input w-full"
          />
        </div>
        <div className="bw-field xl-4">
          <label className="bw-label">Previous CTC</label>
          <input className="bw-input" type="number" value={arrearForm.previous_ctc} onChange={(e) => setArrearForm((p) => ({ ...p, previous_ctc: e.target.value }))} />
        </div>
        <div className="bw-field xl-4">
          <label className="bw-label">New CTC</label>
          <input className="bw-input" type="number" value={arrearForm.new_ctc} onChange={(e) => setArrearForm((p) => ({ ...p, new_ctc: e.target.value }))} />
        </div>
        <div className="bw-field xl-4">
          <label className="bw-label">Effective from</label>
          <DatePickerField hideLabel value={arrearForm.effective_from} onChange={(date) => setArrearForm((p) => ({ ...p, effective_from: date }))} inputClassName="bw-input" />
        </div>
        <div className="bw-field xl-4">
          <label className="bw-label">As of</label>
          <DatePickerField hideLabel value={arrearForm.as_of_date} onChange={(date) => setArrearForm((p) => ({ ...p, as_of_date: date }))} inputClassName="bw-input" />
        </div>
      </div>
      <div className="bw-actions">
        <button type="button" className="bw-btn bw-btn-secondary" onClick={runCompute}>
          Compute arrear
        </button>
        <button type="button" className="bw-btn bw-btn-primary" onClick={saveArrear}>
          Save arrear record
        </button>
      </div>

      {computeResult ? (
        <pre className="rounded-lg bg-slate-900 p-4 text-xs text-slate-100 overflow-auto max-h-64">
          {JSON.stringify(computeResult, null, 2)}
        </pre>
      ) : null}

      <h3 className="bw-section-title">Saved arrears</h3>
      <div className="bw-table-wrap">
        <table className="bw-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Net arrear</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {arrears.map((r) => (
              <tr key={r.arrear_id}>
                <td className="text-xs">{r.employee_id}</td>
                <td>{r.net_arrear}</td>
                <td>{r.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h3 className="bw-section-title">Corrections</h3>
      <div className="bw-table-wrap">
        <table className="bw-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {corrections.map((r) => (
              <tr key={r.correction_id}>
                <td className="text-xs">{r.employee_id}</td>
                <td>{r.correction_type}</td>
                <td>{r.amount}</td>
                <td>{r.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
